import React from "react";
import Icon from "@ant-design/icons";

const TextMessageSvg = ({
	width = "1rem",
	height = "1rem",
	fill = "none",
	stroke = "#344054",
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox={`0 0 ${width} ${height}`}
		height={height}
		width={width}
		fill={fill}
	>
		<path
			d="M6.46875 7.3125C6.46875 7.46783 6.34283 7.59375 6.1875 7.59375C6.03217 7.59375 5.90625 7.46783 5.90625 7.3125C5.90625 7.15717 6.03217 7.03125 6.1875 7.03125C6.34283 7.03125 6.46875 7.15717 6.46875 7.3125ZM6.46875 7.3125H6.1875M9.28125 7.3125C9.28125 7.46783 9.15533 7.59375 9 7.59375C8.84467 7.59375 8.71875 7.46783 8.71875 7.3125C8.71875 7.15717 8.84467 7.03125 9 7.03125C9.15533 7.03125 9.28125 7.15717 9.28125 7.3125ZM9.28125 7.3125H9M12.0938 7.3125C12.0938 7.46783 11.9678 7.59375 11.8125 7.59375C11.6572 7.59375 11.5312 7.46783 11.5312 7.3125C11.5312 7.15717 11.6572 7.03125 11.8125 7.03125C11.9678 7.03125 12.0938 7.15717 12.0938 7.3125ZM12.0938 7.3125H11.8125M1.6875 9.56951C1.6875 10.7703 2.53006 11.8155 3.71809 11.9902C4.53268 12.11 5.35613 12.2025 6.1875 12.2667V15.75L9.32511 12.6124C9.48016 12.4573 9.6895 12.3692 9.9087 12.3638C11.3904 12.3271 12.8498 12.2008 14.2819 11.9903C15.4699 11.8156 16.3125 10.7704 16.3125 9.56959V5.05542C16.3125 3.8546 15.4699 2.80937 14.2819 2.6347C12.558 2.38126 10.7944 2.25 9.00021 2.25C7.20582 2.25 5.44209 2.38128 3.7181 2.63477C2.53006 2.80945 1.6875 3.85467 1.6875 5.05548V9.56951Z"
			stroke={stroke}
			strokeWidth="1.125"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
const TextMessageIcon = (props) => (
	<Icon component={() => <TextMessageSvg {...props} />} />
);

export default TextMessageIcon;
